import { message } from 'antd'
import { QuestionnaireApi } from 'api/Questionnaire'
import AddQuestionnaireSystem
  from 'components/Main/QuestionnaireSystem/AddRating/AddQuestionnaireSystem'
import useFetch from 'elements/Hooks/useFetch'
import useModalData from 'elements/Hooks/useModalData'
import { get, isEmpty } from 'lodash'
import React from 'react'
import { withRouter } from 'react-router-dom'

function AddQuestionnaireSystemCont({ owner, match, templateKey }) {
  const key = owner || get(match, 'params.key')

  const { data, fetching, fetch } = useFetch({
    url: `/questionnaire/owner/?id=${key}`,
    dependencyArray: key,
    suppressAlert: true,
  })

  const templateCode = templateKey || data.temperature
  const { data: template, fetching: fetchingTemplate } = useFetch({
    url: `/questionnaire/template/${templateCode}`,
    dependencyArray: templateCode,
  })

  const {
    submitting,
    checkForm,
    removing,
    remove,
    formRef,
    update,
    setSubmitting,
  } = useModalData(QuestionnaireApi.create, QuestionnaireApi.update, QuestionnaireApi.remove, () => [])

  async function submit() {
    const newObject = await checkForm()
    console.log(newObject)
    setSubmitting(true)
    try {
      await QuestionnaireApi.create({
        results: newObject,
        owner,
        template: templateKey,
      })

      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <AddQuestionnaireSystem
      {...{
        data,
        fetching: fetching || fetchingTemplate,
        template,
        fetch,
        owner,
        formRef,
        submit,
        update,
        isNew: isEmpty(data),
        removing,
        remove,
        submitting,
      }}
    />
  )
}

export default withRouter(AddQuestionnaireSystemCont)
